import React from 'react'
import Navbar from '../inc/Navbar'
import villa3bhk from "../images/3 BHK VILLA photo.jpg";
import { Link } from "react-router-dom";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import villa3bhkphoto from "../images/3bhk villa photo interor.jpg";
import villa3bhkphoto2 from "../images/villa project.jpg";
import LogoSlider from './LogoSlider';


function Bhk3villa() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <div className='krishnagarland'>
                <div className="album py-1">
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "white" }}>Home</Link></li>
                                <li style={{ color: "white" }} className="breadcrumb-item active" aria-current="page">3BHK VILLA</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>     <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 style={{ color: "#B80000" }} className="card-title mb-0"><b> 3BHK <b>VILLA</b></b></h1>
                            <div className="col-md-2">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>

                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-7 mt-3">
                                        <div className='mission'>
                                            <h3 style={{ color: "#1D4D93" }} className='mb-2'>Luxury 3BHK <b>Villa Krishnagar</b></h3>
                                            <p style={{ color: "#1D4D93" }} className='mb-2'>Dear Visitors,</p>

                                            <p className='justify mb-2'>🏡 Affordable Residential Plot with Construction – Prime Location</p>
                                            <p className='justify mb-1'>Approximate budget ₹55,00,000 only.
                                                Built-up area around 1550 sq. ft.
                                                Plot size 2.5 Katha (minimum 2 Katha available).
                                                Wide approach roads – 22 feet & 18 feet road access.
                                                Ideal for residential construction in a well-connected locality.
                                                Perfect choice for families looking for value, space, and convenience.</p>

                                        </div>
                                    </div>
                                    <div className="col-md-5 mt-3">

                                        <img src={villa3bhk} className="card-img-top" alt="villa3bhk" />


                                    </div>





                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>

                <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={villa3bhkphoto} className="card-img-top" alt="best 3bhkvillakrishnagar" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">Main Gate</p>
                                          

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={villa3bhkphoto2} className="card-img-top" alt="villa3bhkphoto"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">Foura Water Design</p>
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                  

                    </div>
                </div>
            </div>
            <LogoSlider/>
            <br/>
        </div>
    )
}

export default Bhk3villa